module.exports = __webpack_public_path__ + "img/img_six_cont3.b307b4be.png";